import { Button } from "@/shared/ui/button.tsx"
import ChatCard from "../ChatCard"
import { ChatMessageType } from "../../types"
import { SetStateAction } from "react";
import { Home } from "lucide-react";

type Props = {
  message: {assistant: string, client: string},
  setStep: (id: ChatMessageType) => void;
  setCanReturn: React.Dispatch<SetStateAction<boolean>>,
  canReturn: boolean
}

const SuccessfulEvent = ({ message, setStep, canReturn, setCanReturn }: Props) => {
  return (
    <>
      <ChatCard user="client">
        <p className="w-full text-end font-poppins text-sm text-gray-500">{message.client}</p>
      </ChatCard>
      <ChatCard user="assistant">
        <div className="w-full flex flex-col gap-8">
          <div className="w-full flex flex-col gap-3 ">
            <h3 className="font-poppins tracking-wider text-xl text-gray-500">...And all set 🎉</h3>
            <p className="font-poppins tracking-wider text-sm text-gray-500">{message.assistant}</p>
            <div className="w-full flex flex-col md:flex-row items-end md:items-center justify-end gap-2 text-xs md:text-sm">
              {canReturn &&
                <Button
                  onClick={() => setStep("result")}
                  variant="outline"
                  className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide  text-xs md:text-sm text-purple-600"
                >
                  Schedule for other platforms
                </Button>
              }
              <Button
                onClick={() => {
                  setCanReturn(true);
                  setStep("first")
                }}
                variant="outline"
                className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600  text-xs md:text-sm"
              >
                Return to themes
              </Button>
              <Button
                onClick={() => setStep("navigation")}
                variant="outline"
                size="icon"
                className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
              >
                <Home />
              </Button>
            </div>
          </div>
        </div>
      </ChatCard>
    </>
  )
}

export default SuccessfulEvent;
